import { handleActions } from "../utils/redux-helper";
import { errorActions } from "../actions/error-actions";

const initialState = {
  showError: false,
  validationError: false,
  failureError: false,
  message: null,
  details: null,
  errorsList: [],
};

const resetError = () => {
  return {
    ...initialState,
  };
};

const errorReducer = handleActions(
  {
    [errorActions.MODAL_CLOSE]: resetError,
    [errorActions.RESPONSE_ERROR]: (state, action) => {
      let errorsList = [];
      if (action.errorsList) {
        if (typeof action.errorsList === "object") {
          Object.keys(action.errorsList).forEach((fieldName) => {
            if (Array.isArray(action.errorsList[fieldName])) {
              errorsList = errorsList.concat(action.errorsList[fieldName]);
            }
          });
        } else {
          errorsList = action.errorsList;
        }
      }

      return {
        ...state,
        showError: true,
        validationError: action.validationError || false,
        failureError: action.failureError || false,
        message: action.message || null,
        details: action.details || null,
        errorsList: errorsList,
      };
    },
  },
  initialState
);

export default errorReducer;
